import { BrowserRouter } from "react-router-dom";
import Routers from "./routes/router";
import "./App.css";
import './App.scss';

function App() {
  return (
    <BrowserRouter>
      <Routers />
    </BrowserRouter>
  );
}

export default App;
